import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import React from "react";
import Navbar from "../../components/Navbar";
import Banner from "../../components/Banner";
import styled from "@emotion/styled";
import { FaUserCheck, FaPeopleArrows } from "react-icons/fa";
import { HiOutlineLightBulb } from "react-icons/hi";
import { FcMoneyTransfer } from "react-icons/fc";
import { MdOutlineManageAccounts } from "react-icons/md";
import Footer from "../../components/Footer";
type ServicesProps = {};

const StyledBox = styled(Box)`
  align: center;
  align: center;
  padding: 50px;
  width: 30%;
`;
const Services: React.FC<ServicesProps> = () => {
  return (
    <>
      <Flex w="100%" h="100vh" direction="column">
        <Navbar />
        <Banner />
        <br />
        <br />
        <Heading
          fontWeight="extrabold"
          // fontSize="lg"
          align="center"
          fontFamily="Poppins, sans-serif"
        >
          Our Service Offerings
        </Heading>
        {/* <br />
        <Box align="center">
          <Flex w="90%" justify="space-between">
            <Text w="30%">
              Human Resources and Industrial Relations Consulting
            </Text>
            <Text w="30%">Recruitment Selection</Text>
            <Text w="30%">Selection Financial and Payroll Services</Text>
          </Flex>
          <Flex w="100%" justify="space-between">
            <Text w="20%">B-BBEE Consulting and turnaround Management</Text>
            <Text w="20%">strategies Supply Chain Management</Text>
            <Text w="20%">Accredited Training and Development</Text>
            <Text w="20%">
              Township revitalisation, Entrepreneurship and Incubation Hubs
              (SED)
            </Text>
          </Flex>
        </Box> */}
      </Flex>
      <Flex align="center" direction="column" p={50}>
        <Flex w="100%" justify="space-around">
          {/* Training and Development */}
          {/* <Box>
        <Heading>Training and Development</Heading>
      </Box> */}
          {/* Human Resource Management */}
          <StyledBox align="center">
            <Box
              border="2px solid"
              borderRadius="100%"
              boxSize="150px"
              p={5}
              color="#46c35f"
            >
              <MdOutlineManageAccounts
                style={{
                  height: "100px",
                  width: "100px",
                }}
              />
            </Box>
            <Heading p={5}>Human Resource Management</Heading>
            <Heading size="md" p={5}>
              Employment Equity planning and reporting
            </Heading>
            <Text>-Setup of 3 / 5 year goals and targets</Text>
            <Text>- EAP profiling Annual online Reporting</Text>
            <Heading size="md" p={5}>
              Skills Development
            </Heading>
            <Text>- Workplace Skills Plan & Annual Training report</Text>
            <Text>
              - Accredited and soft skills courses Registration with SETA (New
              Business)
            </Text>
            <Text>
              -Facilitate internship/learnership and workplace experience
              placements
            </Text>
          </StyledBox>
          {/* Labour Relations Management */}
          {/* <Box>
        <Heading>Labour Relations Management</Heading>
      </Box> */}
          <StyledBox align="center">
            {/* Entrepreneurship and Innovation Hub */}
            <Box
              border="2px solid"
              borderRadius="100%"
              boxSize="150px"
              p={5}
              color="#ffe100"
            >
              <HiOutlineLightBulb size="100px" />
            </Box>
            <Heading p={5}>Entrepreneurship and Innovation Hub</Heading>
            <Text>
              - In conjunction with government, municipalities and our JSE
              listed client base we actively seek out and identify young black
              entrepreneurs with innovative ideas{" "}
            </Text>
            <Text>
              - We provide support both monetary and non monetary to new black
              owned businesses via our clients’ supplier and enterprise
              development budgets
            </Text>
            <Text>
              - We ensure training and mentorship to these new businesses are
              continuous and on-going
            </Text>
          </StyledBox>
          <StyledBox align="center">
            <Box border="2px solid" borderRadius="100%" boxSize="150px" p={5}>
              <FcMoneyTransfer size="100px" />
            </Box>
            <Heading p={5}>Financial and Payroll</Heading>
            <Heading size="md" p={5}>
              Payroll administration service
            </Heading>
            <Text>
              - Administration of statutory payments – PAYE, UIF, Skills Levies
            </Text>
            <Text>
              - Workman’s compensation IRP5 reconciliations at year end
            </Text>
            <Text>-Detailed payroll reports Financial</Text>
            <Heading size="md" p={5}>
              {" "}
              administration service
            </Heading>
            <Text>- Financial accounting for payroll</Text>
            <Text>-Payroll journal entries into General Ledger.</Text>
            <Text>-Reconciliation of payroll related accounts.</Text>
          </StyledBox>
        </Flex>
        <br />
        <Flex w="100%" justify="space-around">
          {/* VALUE PROPOSITION */}
          <StyledBox align="center" h="15%">
            <Box
              boxSize="150px"
              border="2px solid"
              borderRadius="100%"
              pt={8}
              color="#d5440b"
              // color="#d5440b"
            >
              <FaPeopleArrows size="100px" />
            </Box>
            <Heading p={5}>Value Proposition</Heading>
            <Heading size="md" p={5}>
              Procurement
            </Heading>
            <Text>-We are a Total B_BBEE Solutions provider</Text>
            <Text>
              -Our value proposition stems from analytical data of our clients
              with strategic advisory to maximize the B_BBEE score of our
              respective clients
            </Text>
            <Text>
              -We managed your vendor certificate gathering and validate all
              certificates gathered to avert pass rates at the verification
              stage
              <Text></Text>
              -We will advise on all excludable allowances to maximize points on
              Procurement which is the most onerous element of the score card
            </Text>
            <Text>
              -We will provide quarterly reports to identify spend on suppliers
              that are EME, QSE and Genric entities and identify and advise on
              areas of improvement
            </Text>
            <Heading size="md" p={5}>
              Skill Development
            </Heading>
            <Text>
              - Skills development being a priority element must become a
              strategic objective within all companies that will be rated
            </Text>
            <Text>
              -Being a priority element we will measure our clients skills spend
              in order to avoid discounting
            </Text>
            <Text>
              -Correct classification of skills intervention is key to avoid
              pass rates at the point of verification.
            </Text>
            <Text>
              -We also provide almost 27 accredited leanership courses; a
              comprehensive list is at the end of this profile.
            </Text>
          </StyledBox>
          <StyledBox align="center">
            <Box
              boxSize="150px"
              border="2px solid"
              borderRadius="100%"
              pt={8}
              // color="#00ddc3"
              color="#3e9fff"
              // color="#679436"
              // color="#f86624"
            >
              <FaUserCheck size="100px" />
            </Box>
            <Heading p={5}>Recruitment and Selection</Heading>
            <Heading size="md" p={5}>
              Administer placement adverts
            </Heading>
            <Heading size="md" p={5}>
              Screening of potential candidates
            </Heading>
            <Heading size="md" p={5}>
              Interview and shortlist candidates for client
            </Heading>
            <Heading size="md" p={5}>
              Employment administration
            </Heading>
            <Text>- Engagement letters / regret letters</Text>
            <Text>
              - Contracts of employment, restraint of trade and confidentiality
              agreements
            </Text>
            <Text>- Salary structuring</Text>
            <Text>
              - Talent management (career profiling, psychometric profiling)
            </Text>
            <Text>- Succession planning</Text>
          </StyledBox>
        </Flex>
      </Flex>
      <Footer />
    </>
  );
};
export default Services;
